import { Approach, Language, PsiApiResponse } from "@/api/types/responses"
import { Psi } from "@/types";
import { languages } from "@/utils/languages";
import { userAvatars } from "@/utils/userAvatars";

const mapFromApiResponse = (psiResponse: PsiApiResponse): Psi => {
    let psi: Psi = {
        ...psiResponse,
        canHaveFirstAppointment: false,
        formatted_rating: '',
        formatted_profile_image: '',
        formatted_exp: '',
        formatted_intro_video_link: '',
        formatted_latest_ratings: [],
        isPremium: false,
        formatted_approaches: []
    }
    try {
        psi.isPremium = psiResponse.valid_psiapp_plus_subscription_count > 0;
        psi.canHaveFirstAppointment = psiResponse.first_appointment && psiResponse.appointments_with_this_psy_count == 0;
        psi.formatted_rating = (psiResponse.avg_rating || 0).toFixed(1);
        psi.formatted_exp = `${psiResponse.years_exp} ${psiResponse.years_exp > 1 ? "anos" : "ano"} de experiência`

        if (psiResponse.approaches) {
            psi.formatted_approaches = psiResponse.approaches.filter((r: Approach) => r.info != null)

        }
        if (psiResponse.profile_image) {
            psi.formatted_profile_image = `${process.env.VUE_APP_BASE_IMG_URL}${psiResponse.profile_image}`
        } else {
            psi.formatted_profile_image = require('@/assets/img/avatars/1.png')
        }
        if (psiResponse.deleted_at) {
            psi.formatted_profile_image = require('@/assets/img/unavailable_user_square.png')
        }
        if (psi.languages) {
            psi.languages.map((elem: Language) => {
                elem.detail.flag = languages[elem.detail.code].flag;
            });
        }
        if (psiResponse.intro_video_link) {
            psi.formatted_intro_video_link = `https://www.youtube.com/embed/${psiResponse.intro_video_link}`
        }
        if (psiResponse.latest_ratings?.length) {
            psi.formatted_latest_ratings = psiResponse.latest_ratings.filter((elem: any) => elem.user != null).map((elem: any) => {
                return {
                    ...elem,
                    img: userAvatars[elem.user.profile_image || 1],
                    initials: `${elem.user.name.charAt(0)}.`
                }
            })
        }
        return psi
    } catch (e) {
        console.error('getFormattedPsi', e);
    } finally {
        return psi;
    }
}

export default {
    mapFromApiResponse
} as const